import type { CSSProperties, ReactNode } from 'react';
import type { IconName } from '@/components/entities/Sprite/Icon';

export type ToastType = 'success' | 'warning' | 'error' | 'info';

export const toastBaseOptions = {
  duration: 4000,
};

// Applied to Sonner's animated (Framer Motion) toast wrapper to ensure
// `backdrop-filter` renders immediately on mount.
export const toastMotionStyle: CSSProperties = {
  backdropFilter: 'blur(var(--blur-lg, 24px)) saturate(150%)',
  WebkitBackdropFilter: 'blur(var(--blur-lg, 24px)) saturate(150%)',
  borderRadius: 'var(--radius-xl)',
};

export const getToastBaseOptions = (disableTimer?: boolean) => ({
  ...toastBaseOptions,
  duration: disableTimer ? Infinity : toastBaseOptions.duration,
});

export const getToastConfig = (
  type: ToastType,
  title?: string,
  description?: ReactNode,
) => {
  const configByType: Record<ToastType, { title: string; description: ReactNode; iconName: IconName }> = {
    success: {
      title: title ?? '',
      description: description ?? '',
      iconName: 'toast-success',
    },
    warning: {
      title: title ?? 'Warning!',
      description: description ?? '',
      iconName: 'toast-warning',
    },
    error: {
      title: title ?? 'Error!',
      description: description ?? '',
      iconName: 'toast-error',
    },
    info: {
      title: title ?? 'Info!',
      description: description ?? '',
      iconName: 'toast-info',
    },
  };

  return configByType[type];
};
